export default function SessionPanel({ 
  onStart, 
  isGameRunning, 
  onPays, 
  onBetOne, 
  onBetAllCards, 
  onMaxBet, 
  denomination, 
  onDenominationClick, 
  speed, 
  onSpeedClick,
  onAddCredit,
  onCashOut,
  onSaveConfig,
  onLoadConfig,
  credit,
  bets,
  cardSelections,
  creditCapMsg,
  atSessionLimit = false,
  isPremium = false,
  freeGameLimit = 25,
}) {
  const formatDenomination = (value) => {
    if (value >= 1) {
      return `$${value.toFixed(0)}`;
    }
    return `${Math.round(value * 100)}¢`;
  };

  // Disable start if any card with a bet has less than 2 numbers marked
  const hasInvalidCard = Object.keys(bets || {}).some(card => (bets[card] || 0) > 0 && (cardSelections?.[card]?.length || 0) < 2);

  // Calculate if there is enough credit to start a game
  const totalBetCredits = Object.values(bets || {}).reduce((sum, bet) => sum + bet, 0);
  const hasMarkedCard = Object.keys(bets || {}).some(card => (bets[card] || 0) > 0 && (cardSelections?.[card]?.length || 0) >= 2);
  const totalWager = totalBetCredits * denomination;
  const insufficientCredit = totalWager > credit || totalWager === 0 || !hasMarkedCard;

  return (
    <div className="session-panel">
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <button onClick={onBetOne} className="btn" style={{ flex: 1 }}>
            Bet 1
          </button>
          <button onClick={onBetAllCards} className="btn bet-all-btn" style={{ width: '150px' }}>
            Bet All Cards
          </button>
          <button onClick={onMaxBet} className="btn" style={{ flex: 1 }}>
            Max Bet
          </button>
          <button onClick={onPays} className="btn" style={{ flex: 1 }}>
            Pays
          </button>
          <button onClick={onSpeedClick} className="btn speed-btn" style={{ flex: 1, letterSpacing: '2px', fontWeight: 'bold', lineHeight: 1 }}>
            <span style={{ fontSize: '21px', lineHeight: 1, marginRight: '8px' }}>Speed</span>
            {speed === 'Slow' && <><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ffd600', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ffd600', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span></>}
            {speed === 'Med'  && <><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ffd600', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span></>}
            {speed === 'Fast' && <><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span><span style={{ color: '#ff4444', fontSize: '21px', lineHeight: 1, display: 'inline-block', transform: 'scale(1.5)' }}>›</span></>}
          </button>
          <button onClick={onDenominationClick} className="btn" style={{ flex: 1}}>
            {formatDenomination(denomination)}
          </button>

        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button onClick={onCashOut} className="cash-out-btn">
            Reset Credits
          </button>
          <div style={{ position: 'relative' }}>
          <button onClick={onAddCredit} className="add-credit-btn">
            Add $100
          </button>
          {creditCapMsg && (
            <span style={{
              position: 'absolute',
              bottom: '110%',
              right: 0,
              background: '#1a1a1a',
              border: '1px solid #ffd600',
              color: '#ffd600',
              fontSize: '0.75rem',
              fontWeight: '600',
              padding: '5px 10px',
              borderRadius: '6px',
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
              zIndex: 10,
            }}>
              $100 limit on Free plan —{' '}
              <a href="/pricing" style={{ color: '#ffd600', textDecoration: 'underline', pointerEvents: 'auto' }}>
                Upgrade to Premium
              </a>
            </span>
          )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
           {/* <span style={{ color: '#fff', fontWeight: 'bold', marginBottom: '2px',marginTop:'0px' ,fontSize: '12px' }}>Credit</span> */}
          <div className="credit-box">
            {typeof credit === 'number'
              ? `$${credit.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : credit}
          </div>
          </div>
          <div style={{ position: 'relative' }}>
          <button onClick={onStart} className="btn bet-all-btn" 
            disabled={isGameRunning || hasInvalidCard || insufficientCredit}
            title={isGameRunning ? 'Game in progress' : (hasInvalidCard || insufficientCredit ? 'Insufficient credit or invalid bet' : '')}
          >
            Start
          </button>
          </div>
        </div>
      </div>
    </div>
  );
}
